<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <mbs-alert
    *ngIf="isRDMode"
    [attr.data-e2e]="elementsSelector.name.isRDModeAlert"
    [icon]="true"
    [type]="alertType.warning">
    {{ 'wizards:compression_encryption_pre_post_rd_warning' | i18next }}
  </mbs-alert>

  <div class="mbs-wizard_form-content">
    <mbs-form-group
      *ngIf="mainService.allowPrePostActions | async"
      [attr.data-e2e]="elementsSelector.name.allowPrePostActionsBlock">
      <mbs-checkbox
        formControlName="executeCommandBeforeBackup"
        [descriptionOutside]="false"
        [id]="'execute-command-before-backup-checkbox'"
        [label]="isRestore ? ('wizards:restore_pre_action_label' | i18next) : ('wizards:command_before_backup_label' | i18next)"
        (change)="beforeBackupChangeHandler($event)">
        <ng-template checkboxDescription>
          <mbs-form-group>
            <mbs-input
              formControlName="preAction"
              [validationWhitespace]="true"></mbs-input>
          </mbs-form-group>

          <mbs-form-group class="mb-0">
            <mbs-radio
              formControlName="exitOnPreActionFail"
              name="exitOnPreActionFail"
              [id]="'exit-on-pre-action-fail-radio-1'"
              [label]="
                isRestore ? ('wizards:restore_exit_pre_action_failed_label' | i18next) : ('wizards:exit_pre_backup_failed_label' | i18next)
              "
              [value]="true"></mbs-radio>
            <mbs-radio
              formControlName="exitOnPreActionFail"
              name="exitOnPreActionFail"
              [id]="'exit-on-pre-action-fail-radio-2'"
              [label]="
                isRestore
                  ? ('wizards:restore_continue_pre_action_failed_label' | i18next)
                  : ('wizards:continue_pre_backup_failed_label' | i18next)
              "
              [value]="false"></mbs-radio>
          </mbs-form-group>
        </ng-template>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="mainService.allowPrePostActions | async"
      [attr.data-e2e]="elementsSelector.name.allowPrePostActionsSecBlock">
      <mbs-checkbox
        formControlName="executeCommandAfterBackupCompletion"
        [descriptionOutside]="false"
        [id]="'execute-command-after-backup-completion-checkbox'"
        [label]="isRestore ? ('wizards:restore_post_action_label' | i18next) : ('wizards:execute_after_complete_label' | i18next)"
        (change)="afterBackupChangeHandler($event)">
        <ng-template checkboxDescription>
          <mbs-form-group>
            <mbs-input
              formControlName="postAction"
              [validationWhitespace]="true"></mbs-input>
          </mbs-form-group>

          <mbs-form-group class="mb-0">
            <mbs-radio
              formControlName="executePostActionOnSuccess"
              name="executePostActionOnSuccess"
              [id]="'execute-post-action-on-success-radio-1'"
              [label]="isRestore ? ('wizards:restore_post_success_label' | i18next) : ('wizards:execute_post_success_label' | i18next)"
              [value]="true"></mbs-radio>
            <mbs-radio
              formControlName="executePostActionOnSuccess"
              name="executePostActionOnSuccess"
              [id]="'execute-post-action-on-success-radio-2'"
              [label]="
                isRestore ? ('wizards:restore_post_regardless_label' | i18next) : ('wizards:execute_post_regardless_label' | i18next)
              "
              [value]="false"></mbs-radio>
          </mbs-form-group>
        </ng-template>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="(!isUnix || isNetBuild) && !isRestore"
      [attr.data-e2e]="elementsSelector.name.notUnixNotRestore">
      <mbs-checkbox
        formControlName="enableBackupChain"
        [descriptionOutside]="false"
        [id]="'enable-backup-chain-checkbox'"
        [label]="'wizards:execute_follow_label' | i18next"
        (change)="backupChainChangeHandler($event)">
        <ng-template checkboxDescription>
          <mbs-form-group>
            <mbs-select
              class="w-50"
              formControlName="backupChainNextPlan"
              [appendTo]="'.modal-content'"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              [clearable]="false"
              [id]="'overdue-after-success-period-select'"
              [items]="ChainPlans"
              [searchable]="true"></mbs-select>
          </mbs-form-group>

          <mbs-form-group>
            <mbs-radio
              formControlName="executeChainPlanOnSuccess"
              name="executeChainPlanOnSuccess"
              [id]="'execute-chain-plan-on-success-radio-1'"
              [label]="'wizards:execute_specified_label' | i18next"
              [value]="true"></mbs-radio>
            <mbs-radio
              formControlName="executeChainPlanOnSuccess"
              name="executeChainPlanOnSuccess"
              [id]="'execute-chain-plan-on-success-radio-2'"
              [label]="'wizards:execute_specified_regardless_label' | i18next"
              [value]="false"></mbs-radio>
          </mbs-form-group>

          <mbs-form-group class="mb-0">
            <label [class.-disabled]="stepForm.get('ForceFullNextPlan').disabled">
              {{ 'wizards:force_full_backup_text' | i18next }}
            </label>
            <mbs-radio
              formControlName="ForceFullNextPlan"
              name="ForceFullNextPlan"
              [class]="'ml-4'"
              [id]="'force-full-radio-1'"
              [label]="'wizards:force_full_backup_label' | i18next"
              [value]="true"></mbs-radio>
            <mbs-radio
              formControlName="ForceFullNextPlan"
              name="ForceFullNextPlan"
              [class]="'ml-4'"
              [id]="'force-full-radio-2'"
              [label]="'wizards:not_force_full_backup_label' | i18next"
              [value]="false">
              <ng-container appendLabel>
                <span
                  class="fa fa-info-circle ml-2 cursor-help text-info"
                  container="body"
                  [ngbTooltip]="'wizards:force_full_backup_tooltip' | i18next"></span>
              </ng-container>
            </mbs-radio>
          </mbs-form-group>
        </ng-template>
      </mbs-checkbox>
    </mbs-form-group>
  </div>
</section>
